import Select from '@/components/ui/Select';
import {
  ETAT_ENTRETIEN_VETUSTE_OPTIONS,
  STANDING_OPTIONS,
} from '@/constants/enums';

export default function SectionEtatStanding({ data, onChange }) {
  const val = (field) =>
    field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);

  return (
    <section className="space-y-6">
      <h3 className="text-lg font-semibold text-slate-800">État et standing</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label="État d'entretien / Vétusté"
          name="etat_entretien"
          value={val('etat_entretien')}
          options={ETAT_ENTRETIEN_VETUSTE_OPTIONS}
          onChange={handleChange('etat_entretien')}
        />
        <Select
          label="Standing de la propriété"
          name="standing_propriete"
          value={val('standing_propriete')}
          options={STANDING_OPTIONS}
          onChange={handleChange('standing_propriete')}
        />
      </div>
    </section>
  );
}
